export const Y_AXIS_WIDTH = 44
export const CHART_MARGIN = { top: 20, right: 14, bottom: 2, left: 0 }

export const doyToDate = (doy) => new Date(Date.UTC(2024, 0, doy))

export const formatDoyLabel = (doy) => {
  if (!doy) return ''
  return doyToDate(doy).toLocaleDateString('en-US', { month: 'short', timeZone: 'UTC' })
}

export const formatDoyFull = (doy) => {
  if (!doy) return ''
  return doyToDate(doy).toLocaleDateString('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' })
}
